import { useNavigate } from 'react-router-dom';
/////////////////////////////////////////////////////////
import { useCustomDispatch } from '@/core/redux/hooks';
import { Skin as SkinInterface } from '@/core/interfaces';
import { setActivePage } from '@/core/redux/slices';

interface SkinProps {
	skin: SkinInterface;
}

export const SkinCard: React.FC<SkinProps> = ({ skin }: SkinProps) => {
	/*********************
	// #region Hooks
	**********************/
	const navigate = useNavigate();
	const dispatch = useCustomDispatch();

	/*********************
	// #region Functions
	**********************/
	const handleRedirectToSkin = () => {
		if (!skin.expired || skin.owned) {
			dispatch(setActivePage(skin.id));
			navigate(`/skins/${skin.id}`);
		}
	};
	/*********************
	// #region Template
	**********************/
	return (
		<div
			className="flex flex-col rounded-2xl items-center bg-vottun-900/50 p-3 relative"
			onClick={handleRedirectToSkin}
		>
			<img src={skin.cover} className="w-full rounded-2xl" />
			<p className="font-bold mt-3">{skin.name}</p>

			{skin.expired && !skin.owned && (
				<div className="absolute top-0 left-0 bg-black/80 w-full h-full flex justify-center items-center rounded-2xl">
					<span className="font-bold text-xl text-uppercase">
						SOLD OUT
					</span>
				</div>
			)}
		</div>
	);
};
